<div class="card mobile-card">
	<div class="card-body p-2">
		@if (isSelectionEnabled) {
			<div class="d-flex align-items-center mb-2 pb-2 border-bottom">
				<div class="form-check">
					<input type="checkbox" class="form-check-input" [checked]="isSelected()" (change)="toggleSelection($event)" />
					<label class="form-check-label ms-2">Seleziona</label>
				</div>
			</div>
		}
		@for (col of columns; track col) {
			<div class="mobile-row mb-2 pb-2 border-bottom">
				@if (isVisible(col) && col.getColDef().headerName !== 'Actions' && col.getColDef().headerName !== 'Azioni') {
					<div class="d-flex justify-content-between align-items-center">
						<span class="fw-bold text-muted mobile-label">{{ col.getColDef().headerName | translate }}</span>
						<span class="text-end mobile-value">
							@if (isBtnRenderer(col)) {
								<button [class]="getBtnClass(col)" (click)="onBtnClick(col)">
									@if (getBtnIcon(col)) {
										<fa-icon [icon]="getBtnIcon(col)"></fa-icon>
									}
									{{ getBtnText(col) }}
								</button>
							} @else {
								@if (isBtnIconRenderer(col)) {
									<button [class]="getBtnIconClass(col)" (click)="onBtnIconClick(col)">
										<fa-icon [icon]="getBtnIconIcon(col)"></fa-icon>
									</button>
								} @else {
									@if (isStatusRenderer(col)) {
										<app-status-cell-renderer [rowData]="data"></app-status-cell-renderer>
									} @else {
										{{ getValue(col) }}
									}
								}
							}
						</span>
					</div>
				}
			</div>
		}
	</div>
</div>
